<template>
  <div>
    <!-- Map-->
    <div id="map2d">
    <gmap-map
        :zoom="zoom"    
        :center="center"
        style="width:100%;  height: 600px;" id="map-container" v-if="this.showMap"
      ><gmap-marker
        :key="index"
        v-for="(m, index) in locationMarkers"
          :position="m.position"
          :title="m.title"
          :icon="m.icon"
          :clickable="true"
          @click="toggleInfoWindow(m, index)"
      ></gmap-marker>
      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="closeInfoWindow()"
      ><div v-html="infoContent"></div>
      </gmap-info-window>
    </gmap-map>
    </div>

    <!-- Device Info Box -->
    <div id = "marker-data-container-container">
      <div id="marker-data-container">
        <br />

        <div id="device-info-box" style="display: none;">

          <img style="display: inline-block; width: 65px; vertical-align: top;" src="../assets/images/4.png" alt="...">

          <div style="display: inline-block; padding-left: 10px;" v-if="location == 'Vitrafy'">
            <b>Location:</b> Ballarat (Vitrafy Lab)
            <br />
            <b>Device:</b> Vitrafy-00004
            <br />
            <b>Type:</b> Cryopreservation Apparatus
          </div>

          <div style="display: inline-block; padding-left: 10px;" v-if="location == 'Hobart'">
            <b>Location:</b> Hobart (Huon Aquaculture)
            <br />
            <b>Device:</b> Vitrafy-00001
            <br />
            <b>Type:</b> Cryopreservation Apparatus        
          </div>
          
          <div style="display: inline-block; padding-left: 10px;" v-if="location == 'Texas'">
            <b>Location:</b> Texas (BioBridge Global)
            <br />
            <b>Device:</b> Vitrafy-00002
            <br />
            <b>Type:</b> Cryopreservation Apparatus        
          </div>

          <div style="display: inline-block; padding-left: 10px;" v-if="location == 'Sydney'">
            <b>Location:</b> Sydney (Australian Red Cross Lifeblood)
            <br />
            <b>Device:</b> Vitrafy-00003
            <br />
            <b>Type:</b> Cryopreservation Apparatus        
          </div>
        </div>    
        
        <!-- loading spinner -->
        <div id = "tracking-data-loading" style="display: none; margin-top: 0">
            <div class="lds-facebook"><div></div><div></div><div></div></div>
            <div>Loading device data...</div>
        </div>

        <!-- Hobart Data Table -->
        <div id="tracking-data-hobart" class="data-table" style="display: none; overflow-x: scroll">
          <br />
          <table class="table">
              <thead>
              <tr>
                  <th>Start DateTime</th>
                  <th>End DateTime</th>
                  <th>Protocol OEMCode</th>
                  <th>Protocol OEMDesc</th>
                  <th>Product Desc</th>
                  <th>Pack Quantity</th>
                  <th>Pack Volume</th>
                  <th>Product Volume</th>
                  <th>CPA</th>
                  <th>Temp Setpoint</th>
                  <th>Temp Tol</th>
                  <th>Flow</th>
                  <th>Flow Tol</th>
                  <th>Process Time</th>
                  <th>Start Temp</th>
                  <th>End Temp</th>
                  <th>Min Temp</th>
                  <th>Max Temp</th>
                  <th>Start Flow</th>
                  <th>End Flow</th>
                  <th>Min Flow</th>
                  <th>Max Flow</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>17/05/2022 14:35:50</td>
                <td>17/05/2022 14:39:50</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>Salmon</td>
                <td>4</td>
                <td>5</td>
                <td>5</td>
                <td>75</td>
                <td>-50</td>
                <td>2.00</td>
                <td>40</td>
                <td>10</td>
                <td>240</td>
                <td>-51.79</td>
                <td>-50.52</td>
                <td>-51.79</td>
                <td>-50.52</td>
                <td>41.11</td>
                <td>40.67</td>
                <td>37.06</td>
                <td>43.47</td>
              </tr>
              <tr>
                <td>17/05/2022 14:28:07</td>
                <td>17/05/2022 14:32:08</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>Semen</td>
                <td>7</td>
                <td>5</td>
                <td>5</td>
                <td>75</td>
                <td>-50</td>
                <td>2.00</td>
                <td>40</td>
                <td>10</td>
                <td>240</td>
                <td>-51.82</td>
                <td>-52.38</td>
                <td>-52.38</td>
                <td>-51.82</td>
                <td>19.88</td>
                <td>42.77</td>
                <td>17.16</td>
                <td>59.07</td>
              </tr>
              <tr>
                <td>17/05/2022 14:00:26</td>
                <td>17/05/2022 14:02:27</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>2</td>
                <td>11</td>
                <td>11</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.83</td>
                <td>-50.16</td>
                <td>-50.16</td>
                <td>-49.83</td>
                <td>41.33</td>
                <td>38.18</td>
                <td>35.77</td>
                <td>44.18</td>
              </tr>
              <tr>
                <td>17/05/2022 13:57:10</td>
                <td>17/05/2022 13:59:11</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-50.31</td>
                <td>-49.66</td>
                <td>-50.40</td>
                <td>-49.66</td>
                <td>40.93</td>
                <td>40.97</td>
                <td>37.34</td>
                <td>44.60</td>
              </tr>
              <tr>
                <td>17/05/2022 13:53:28</td>
                <td>17/05/2022 13:55:29</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.92</td>
                <td>-49.81</td>
                <td>-50.00</td>
                <td>-49.48</td>
                <td>41.52</td>
                <td>37.41</td>
                <td>36.65</td>
                <td>43.04</td>
              </tr>
              <tr>
                <td>17/05/2022 13:49:30</td>
                <td>17/05/2022 13:51:29</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>4</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-50.14</td>
                <td>-49.87</td>
                <td>-50.26</td>
                <td>-49.87</td>
                <td>43.53</td>
                <td>39.98</td>
                <td>36.89</td>
                <td>43.72</td>
              </tr>
              <tr>
                <td>17/05/2022 13:45:28</td>
                <td>17/05/2022 13:47:27</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.75</td>
                <td>-49.56</td>
                <td>-49.81</td>
                <td>-49.47</td>
                <td>41.34</td>
                <td>38.25</td>
                <td>37.59</td>
                <td>43.72</td>
              </tr>
              <tr>
                <td>17/05/2022 13:38:41</td>
                <td>17/05/2022 13:40:41</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Test</td>
                <td>7</td>
                <td>17</td>
                <td>17</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.81</td>
                <td>-50.40</td>
                <td>-50.40</td>
                <td>-49.81</td>
                <td>38.32</td>
                <td>40.69</td>
                <td>36.36</td>
                <td>44.31</td>
              </tr>
              <tr>
                <td>17/05/2022 12:23:46</td>
                <td>17/05/2022 12:25:47</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>5</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.66</td>
                <td>-49.81</td>
                <td>-49.81</td>
                <td>-49.66</td>
                <td>41.35</td>
                <td>39.61</td>
                <td>36.71</td>
                <td>44.27</td>
              </tr>
              <tr>
                <td>17/05/2022 12:20:53</td>
                <td>17/05/2022 12:22:53</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.75</td>
                <td>-49.48</td>
                <td>-49.77</td>
                <td>-49.37</td>
                <td>39.91</td>
                <td>43.72</td>
                <td>36.06</td>
                <td>44.84</td>
              </tr>
              <tr>
                <td>17/05/2022 12:10:58</td>
                <td>17/05/2022 12:12:58</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>4</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.86</td>
                <td>-50.01</td>
                <td>-50.01</td>
                <td>-49.85</td>
                <td>41.20</td>
                <td>41.45</td>
                <td>36.47</td>
                <td>42.74</td>
              </tr>
              <tr>
                <td>17/05/2022 12:07:34</td>
                <td>17/05/2022 12:09:34</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.73</td>
                <td>-49.60</td>
                <td>-49.73</td>
                <td>-49.48</td>
                <td>41.15</td>
                <td>38.39</td>
                <td>36.56</td>
                <td>43.39</td>
              </tr>
              <tr>
                <td>17/05/2022 11:45:24</td>
                <td>17/05/2022 11:47:23</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>5</td>
                <td>10</td>
                <td>10</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-50.02</td>
                <td>-49.79</td>
                <td>-50.13</td>
                <td>-49.79</td>
                <td>38.66</td>
                <td>37.59</td>
                <td>36.28</td>
                <td>43.00</td>
              </tr>
              <tr>
                <td>17/05/2022 11:41:00</td>
                <td>17/05/2022 11:43:00</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>4</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-50.09</td>
                <td>-49.88</td>
                <td>-50.19</td>
                <td>-49.88</td>
                <td>42.67</td>
                <td>40.02</td>
                <td>17.98</td>
                <td>55.98</td>
              </tr>
              <tr>
                <td>17/05/2022 11:37:48</td>
                <td>17/05/2022 11:39:49</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.95</td>
                <td>-49.87</td>
                <td>-50.03</td>
                <td>-49.72</td>
                <td>42.54</td>
                <td>39.75</td>
                <td>17.81</td>
                <td>52.74</td>
              </tr>
              <tr>
                <td>17/05/2022 11:22:36</td>
                <td>17/05/2022 11:24:36</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>2</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.92</td>
                <td>-50.28</td>
                <td>-50.28</td>
                <td>-49.92</td>
                <td>41.90</td>
                <td>41.99</td>
                <td>36.68</td>
                <td>43.71</td>
              </tr>
              <tr>
                <td>17/05/2022 11:19:54</td>
                <td>17/05/2022 11:21:54</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.80</td>
                <td>-49.78</td>
                <td>-49.92</td>
                <td>-49.64</td>
                <td>39.77</td>
                <td>40.67</td>
                <td>36.33</td>
                <td>42.77</td>
              </tr>
              <tr>
                <td>17/05/2022 11:16:11</td>
                <td>17/05/2022 11:18:11</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.79</td>
                <td>-49.41</td>
                <td>-49.79</td>
                <td>-49.17</td>
                <td>39.07</td>
                <td>39.60</td>
                <td>37.61</td>
                <td>41.88</td>
              </tr>
              <tr>
                <td>17/05/2022 10:40:35</td>
                <td>17/05/2022 10:42:37</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>3</td>
                <td>5</td>
                <td></td>
                <td> </td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-50.05</td>
                <td>-50.01</td>
                <td>-50.17</td>
                <td>-50.01</td>
                <td>40.98</td>
                <td>39.40</td>
                <td>36.27</td>
                <td>44.08</td>
              </tr>
              <tr>
                <td>17/05/2022 10:37:05</td>
                <td>17/05/2022 10:39:05</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-50.17</td>
                <td>-49.69</td>
                <td>-50.27</td>
                <td>-49.68</td>
                <td>40.46</td>
                <td>39.47</td>
                <td>36.74</td>
                <td>43.75</td>
              </tr>
              <tr>
                <td>17/05/2022 10:32:38</td>
                <td>17/05/2022 10:34:39</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.79</td>
                <td>-49.46</td>
                <td>-49.79</td>
                <td>-49.34</td>
                <td>39.21</td>
                <td>39.30</td>
                <td>36.44</td>
                <td>42.29</td>
              </tr>
              <tr>
                <td>17/05/2022 10:19:48</td>
                <td>17/05/2022 10:21:48</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>3</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.85</td>
                <td>-50.20</td>
                <td>-50.20</td>
                <td>-49.85</td>
                <td>41.28</td>
                <td>42.18</td>
                <td>36.73</td>
                <td>43.13</td>
              </tr>
              <tr>
                <td>17/05/2022 10:16:55</td>
                <td>17/05/2022 10:18:55</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.67</td>
                <td>-49.65</td>
                <td>-49.78</td>
                <td>-49.52</td>
                <td>37.69</td>
                <td>38.46</td>
                <td>37.53</td>
                <td>42.50</td>
              </tr>
              <tr>
                <td>17/05/2022 10:13:50</td>
                <td>17/05/2022 10:15:50</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.78</td>
                <td>-49.40</td>
                <td>-49.78</td>
                <td>-49.35</td>
                <td>41.45</td>
                <td>42.43</td>
                <td>37.19</td>
                <td>43.57</td>
              </tr>
              <tr>
                <td>17/05/2022 09:55:19</td>
                <td>17/05/2022 09:57:19</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>1</td>
                <td>10</td>
                <td>5</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-50.38</td>
                <td>-50.04</td>
                <td>-50.38</td>
                <td>-50.04</td>
                <td>38.79</td>
                <td>39.23</td>
                <td>36.03</td>
                <td>42.85</td>
              </tr>
              <tr>
                <td>17/05/2022 09:52:01</td>
                <td>17/05/2022 09:54:00</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>2</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.67</td>
                <td>-50.08</td>
                <td>-50.08</td>
                <td>-49.67</td>
                <td>39.82</td>
                <td>38.41</td>
                <td>37.65</td>
                <td>42.31</td>
              </tr>
              <tr>
                <td>17/05/2022 09:48:59</td>
                <td>17/05/2022 09:51:00</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.44</td>
                <td>-49.47</td>
                <td>-49.56</td>
                <td>-49.29</td>
                <td>39.88</td>
                <td>39.18</td>
                <td>36.56</td>
                <td>44.31</td>
              </tr>
              <tr>
                <td>17/05/2022 09:45:49</td>
                <td>17/05/2022 09:47:49</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Salmon</td>
                <td>7</td>
                <td>12</td>
                <td>12</td>
                <td>75</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-49.96</td>
                <td>-49.20</td>
                <td>-49.97</td>
                <td>-49.15</td>
                <td>39.16</td>
                <td>38.76</td>
                <td>37.05</td>
                <td>42.52</td>
              </tr>
              <tr>
                <td>17/05/2022 09:01:07</td>
                <td>17/05/2022 09:03:08</td>
                <td>00:00.0</td>
                <td>Salmon -50/40</td>
                <td>Test</td>
                <td>4</td>
                <td>12</td>
                <td>12</td>
                <td>50</td>
                <td>-50</td>
                <td>0.10</td>
                <td>40</td>
                <td>5</td>
                <td>120</td>
                <td>-50.54</td>
                <td>-50.41</td>
                <td>-50.59</td>
                <td>-50.41</td>
                <td>40.53</td>
                <td>39.88</td>
                <td>36.74</td>
                <td>43.35</td>
              </tr>
              </tbody>
          </table>
        </div>

        <!-- Ballarat Data Table -->
        <div id="tracking-data-ballarat" class="data-table" style="display: none; overflow-x: scroll">
          <br />
          <table class="table">
              <thead>
                <tr>
                    <th>Start DateTime</th>
                    <th>End DateTime</th>
                    <th>Protocol OEMCode</th>
                    <th>Protocol OEMDesc</th>
                    <th>Product Desc</th>
                    <th>Pack Quantity</th>
                    <th>Pack Volume</th>
                    <th>Product Volume</th>
                    <th>CPA</th>
                    <th>Temp Setpoint</th>
                    <th>Temp Tol</th>
                    <th>Flow</th>
                    <th>Flow Tol</th>
                    <th>Process Time</th>
                    <th>Start Temp</th>
                    <th>End Temp</th>
                    <th>Min Temp</th>
                    <th>Max Temp</th>
                    <th>Start Flow</th>
                    <th>End Flow</th>
                    <th>Min Flow</th>
                    <th>Max Flow</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>10/05/2022 13:04:04</td>
                  <td>10/05/2022 13:08:05</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>4</td>
                  <td>2</td>
                  <td>0.5</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-47.49</td>
                  <td>-45.78</td>
                  <td>-47.49</td>
                  <td>-45.66</td>
                  <td>60.08</td>
                  <td>59.86</td>
                  <td>59.41</td>
                  <td>60.53</td>
                </tr>
                <tr>
                  <td>10/05/2022 12:57:52</td>
                  <td>10/05/2022 12:58:52</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>4</td>
                  <td>0.5</td>
                  <td>0.5</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-50.20</td>
                  <td>-49.17</td>
                  <td>-50.20</td>
                  <td>-49.17</td>
                  <td>59.61</td>
                  <td>60.33</td>
                  <td>59.59</td>
                  <td>60.82</td>
                </tr>
                <tr>
                  <td>10/05/2022 10:25:11</td>
                  <td>10/05/2022 10:29:11</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>4</td>
                  <td>1.5</td>
                  <td>0.5</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-50.07</td>
                  <td>-48.82</td>
                  <td>-50.07</td>
                  <td>-48.64</td>
                  <td>59.22</td>
                  <td>60.07</td>
                  <td>59.22</td>
                  <td>60.85</td>
                </tr>
                <tr>
                  <td>10/05/2022 10:13:25</td>
                  <td>10/05/2022 10:14:25</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>4</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-50.21</td>
                  <td>-50.33</td>
                  <td>-50.33</td>
                  <td>-50.21</td>
                  <td>59.76</td>
                  <td>60.43</td>
                  <td>59.30</td>
                  <td>60.69</td>
                </tr>
                <tr>
                  <td>09/05/2022 13:49:47</td>
                  <td>09/05/2022 13:50:47</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-49.51</td>
                  <td>-48.83</td>
                  <td>-49.51</td>
                  <td>-48.83</td>
                  <td>60.34</td>
                  <td>59.62</td>
                  <td>59.39</td>
                  <td>60.73</td>
                </tr>
                <tr>
                  <td>09/05/2022 13:44:46</td>
                  <td>09/05/2022 13:45:50</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-50.91</td>
                  <td>-50.72</td>
                  <td>-50.94</td>
                  <td>-50.72</td>
                  <td>59.84</td>
                  <td>60.57</td>
                  <td>58.75</td>
                  <td>61.18</td>
                </tr>
                <tr>
                  <td>03/05/2022 13:30:51</td>
                  <td>03/05/2022 13:31:50</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-49.60</td>
                  <td>-48.66</td>
                  <td>-49.60</td>
                  <td>-48.66</td>
                  <td>51.75</td>
                  <td>51.48</td>
                  <td>50.80</td>
                  <td>53.89</td>
                </tr>
                <tr>
                  <td>03/05/2022 13:24:01</td>
                  <td>03/05/2022 13:28:01</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>2</td>
                  <td>0.5</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-50.82</td>
                  <td>-50.58</td>
                  <td>-50.82</td>
                  <td>-50.56</td>
                  <td>53.99</td>
                  <td>50.81</td>
                  <td>49.58</td>
                  <td>54.45</td>
                </tr>
                <tr>
                  <td>03/05/2022 10:33:41</td>
                  <td>03/05/2022 10:37:41</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>1.5</td>
                  <td>0.5</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-50.03</td>
                  <td>-48.00</td>
                  <td>-50.03</td>
                  <td>-47.99</td>
                  <td>59.81</td>
                  <td>60.56</td>
                  <td>59.14</td>
                  <td>61.18</td>
                </tr>
                <tr>
                  <td>03/05/2022 10:12:55</td>
                  <td>03/05/2022 10:13:54</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-50.42</td>
                  <td>-50.19</td>
                  <td>-50.45</td>
                  <td>-50.19</td>
                  <td>59.66</td>
                  <td>59.86</td>
                  <td>59.43</td>
                  <td>60.47</td>
                </tr>
                <tr>
                  <td>03/05/2022 10:06:21</td>
                  <td>03/05/2022 10:07:21</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-50.18</td>
                  <td>-50.21</td>
                  <td>-50.26</td>
                  <td>-50.18</td>
                  <td>60.12</td>
                  <td>59.83</td>
                  <td>59.45</td>
                  <td>61.57</td>
                </tr>
                <tr>
                  <td>02/05/2022 13:40:12</td>
                  <td>02/05/2022 13:44:12</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>2</td>
                  <td>0.5</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-49.23</td>
                  <td>-47.93</td>
                  <td>-49.23</td>
                  <td>-47.82</td>
                  <td>59.41</td>
                  <td>60.23</td>
                  <td>59.09</td>
                  <td>60.81</td>
                </tr>
                <tr>
                  <td>02/05/2022 13:23:09</td>
                  <td>02/05/2022 13:24:09</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-48.43</td>
                  <td>-47.51</td>
                  <td>-48.43</td>
                  <td>-47.51</td>
                  <td>60.44</td>
                  <td>60.46</td>
                  <td>59.40</td>
                  <td>60.65</td>
                </tr>
                <tr>
                  <td>26/04/2022 13:43:22</td>
                  <td>26/04/2022 13:47:21</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>10</td>
                  <td>1.5</td>
                  <td>1</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-47.38</td>
                  <td>-46.12</td>
                  <td>-47.40</td>
                  <td>-46.05</td>
                  <td>57.94</td>
                  <td>57.58</td>
                  <td>57.25</td>
                  <td>58.99</td>
                </tr>
                <tr>
                  <td>26/04/2022 13:24:49</td>
                  <td>26/04/2022 13:25:49</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-50.97</td>
                  <td>-50.69</td>
                  <td>-50.98</td>
                  <td>-50.69</td>
                  <td>59.93</td>
                  <td>60.09</td>
                  <td>59.28</td>
                  <td>61.10</td>
                </tr>
                <tr>
                  <td>26/04/2022 13:00:09</td>
                  <td>26/04/2022 13:01:09</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>-0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-49.68</td>
                  <td>-49.47</td>
                  <td>-49.72</td>
                  <td>-49.46</td>
                  <td>60.93</td>
                  <td>59.35</td>
                  <td>59.28</td>
                  <td>61.15</td>
                </tr>
                <tr>
                  <td>26/04/2022 11:40:15</td>
                  <td>26/04/2022 11:44:15</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>8</td>
                  <td>1.5</td>
                  <td>1</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-49.55</td>
                  <td>-47.77</td>
                  <td>-49.55</td>
                  <td>-47.76</td>
                  <td>60.27</td>
                  <td>59.47</td>
                  <td>59.28</td>
                  <td>61.34</td>
                </tr>
                <tr>
                  <td>26/04/2022 11:19:15</td>
                  <td>26/04/2022 11:20:14</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-49.73</td>
                  <td>-49.15</td>
                  <td>-49.74</td>
                  <td>-49.15</td>
                  <td>59.79</td>
                  <td>60.70</td>
                  <td>59.05</td>
                  <td>61.00</td>
                </tr>
                <tr>
                  <td>21/04/2022 13:15:14</td>
                  <td>21/04/2022 13:18:14</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Wb </td>
                  <td>4</td>
                  <td>10</td>
                  <td>40</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>180</td>
                  <td>-49.57</td>
                  <td>-47.74</td>
                  <td>-49.57</td>
                  <td>-47.69</td>
                  <td>60.03</td>
                  <td>60.20</td>
                  <td>59.37</td>
                  <td>60.60</td>
                </tr>
                <tr>
                  <td>21/04/2022 13:08:01</td>
                  <td>21/04/2022 13:12:00</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Wb ld </td>
                  <td>7</td>
                  <td>1</td>
                  <td>5</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-50.40</td>
                  <td>-50.65</td>
                  <td>-50.66</td>
                  <td>-50.40</td>
                  <td>60.05</td>
                  <td>59.64</td>
                  <td>59.30</td>
                  <td>60.91</td>
                </tr>
                <tr>
                  <td>19/04/2022 13:37:34</td>
                  <td>19/04/2022 13:41:29</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>1.5</td>
                  <td>1</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-48.00</td>
                  <td>-45.35</td>
                  <td>-48.00</td>
                  <td>-45.35</td>
                  <td>49.63</td>
                  <td>46.89</td>
                  <td>45.51</td>
                  <td>50.38</td>
                </tr>
                <tr>
                  <td>19/04/2022 13:26:02</td>
                  <td>19/04/2022 13:27:02</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-50.59</td>
                  <td>-50.30</td>
                  <td>-50.61</td>
                  <td>-50.29</td>
                  <td>52.26</td>
                  <td>52.75</td>
                  <td>49.25</td>
                  <td>52.75</td>
                </tr>
                <tr>
                  <td>19/04/2022 12:25:36</td>
                  <td>19/04/2022 12:26:36</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-49.69</td>
                  <td>-49.40</td>
                  <td>-49.70</td>
                  <td>-49.39</td>
                  <td>54.87</td>
                  <td>54.83</td>
                  <td>53.85</td>
                  <td>55.84</td>
                </tr>
                <tr>
                  <td>19/04/2022 12:17:11</td>
                  <td>19/04/2022 12:21:11</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>1.5</td>
                  <td>0.5</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-50.10</td>
                  <td>-49.11</td>
                  <td>-50.11</td>
                  <td>-49.08</td>
                  <td>60.63</td>
                  <td>60.14</td>
                  <td>58.18</td>
                  <td>61.01</td>
                </tr>
                <tr>
                  <td>13/04/2022 10:04:50</td>
                  <td>13/04/2022 10:07:47</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>We l v</td>
                  <td>6</td>
                  <td>6</td>
                  <td>6</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>180</td>
                  <td>-51.10</td>
                  <td>-48.63</td>
                  <td>-51.10</td>
                  <td>-48.63</td>
                  <td>59.82</td>
                  <td>60.25</td>
                  <td>59.25</td>
                  <td>60.98</td>
                </tr>
                <tr>
                  <td>13/04/2022 09:58:51</td>
                  <td>13/04/2022 10:00:51</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Wb l</td>
                  <td>2</td>
                  <td>10</td>
                  <td>10</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>120</td>
                  <td>-50.55</td>
                  <td>-50.85</td>
                  <td>-50.85</td>
                  <td>-50.55</td>
                  <td>60.89</td>
                  <td>60.19</td>
                  <td>59.03</td>
                  <td>60.89</td>
                </tr>
                <tr>
                  <td>06/04/2022 10:46:15</td>
                  <td>06/04/2022 10:48:15</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>We l</td>
                  <td>3</td>
                  <td>1</td>
                  <td>1</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>120</td>
                  <td>-48.10</td>
                  <td>-48.10</td>
                  <td>-48.11</td>
                  <td>-48.06</td>
                  <td>21.76</td>
                  <td>21.65</td>
                  <td>19.33</td>
                  <td>24.10</td>
                </tr>
                <tr>
                  <td>06/04/2022 10:16:39</td>
                  <td>06/04/2022 10:19:39</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Wb l</td>
                  <td>10</td>
                  <td>10</td>
                  <td>10</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>180</td>
                  <td>-48.10</td>
                  <td>-47.80</td>
                  <td>-48.10</td>
                  <td>-47.80</td>
                  <td>28.37</td>
                  <td>25.38</td>
                  <td>22.70</td>
                  <td>30.33</td>
                </tr>
                <tr>
                  <td>06/04/2022 10:12:14</td>
                  <td>06/04/2022 10:15:15</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>We l</td>
                  <td>10</td>
                  <td>10</td>
                  <td>10</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>180</td>
                  <td>-50.73</td>
                  <td>-49.08</td>
                  <td>-50.73</td>
                  <td>-49.08</td>
                  <td>40.58</td>
                  <td>33.89</td>
                  <td>32.72</td>
                  <td>42.37</td>
                </tr>
                <tr>
                  <td>06/04/2022 10:08:00</td>
                  <td>06/04/2022 10:10:59</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>L wb</td>
                  <td>3</td>
                  <td>30</td>
                  <td>30</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>180</td>
                  <td>-51.12</td>
                  <td>-50.91</td>
                  <td>-51.12</td>
                  <td>-50.90</td>
                  <td>59.70</td>
                  <td>49.94</td>
                  <td>49.51</td>
                  <td>59.70</td>
                </tr>
                <tr>
                  <td>05/04/2022 22:51:06</td>
                  <td>05/04/2022 22:51:16</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>man</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>10</td>
                  <td>-49.53</td>
                  <td>-49.50</td>
                  <td>-49.53</td>
                  <td>-49.50</td>
                  <td>60.24</td>
                  <td>60.08</td>
                  <td>59.78</td>
                  <td>60.24</td>
                </tr>
                <tr>
                  <td>05/04/2022 22:46:56</td>
                  <td>05/04/2022 22:47:15</td>
                  <td>3</td>
                  <td>Test Protocol</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>-50</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>20</td>
                  <td>-49.68</td>
                  <td>-49.53</td>
                  <td>-49.68</td>
                  <td>-49.53</td>
                  <td>63.47</td>
                  <td>63.17</td>
                  <td>63.17</td>
                  <td>63.87</td>
                </tr>
                <tr>
                  <td>05/04/2022 22:45:51</td>
                  <td>05/04/2022 22:46:10</td>
                  <td>3</td>
                  <td>Test Protocol</td>
                  <td>4</td>
                  <td>5</td>
                  <td>5</td>
                  <td>55</td>
                  <td>NULL</td>
                  <td>-50</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>20</td>
                  <td>-50.17</td>
                  <td>-50.08</td>
                  <td>-50.18</td>
                  <td>-50.08</td>
                  <td>63.12</td>
                  <td>63.10</td>
                  <td>62.83</td>
                  <td>63.36</td>
                </tr>
                <tr>
                  <td>05/04/2022 22:30:20</td>
                  <td>05/04/2022 22:32:50</td>
                  <td>2</td>
                  <td>Vitrafy Protocol 00002</td>
                  <td>b</td>
                  <td>2</td>
                  <td>2</td>
                  <td>2</td>
                  <td>2</td>
                  <td>-30</td>
                  <td>1</td>
                  <td>39</td>
                  <td>5</td>
                  <td>150</td>
                  <td>-50.01</td>
                  <td>-49.09</td>
                  <td>-50.01</td>
                  <td>-49.09</td>
                  <td>38.21</td>
                  <td>38.17</td>
                  <td>37.00</td>
                  <td>40.94</td>
                </tr>
                <tr>
                  <td>05/04/2022 22:29:00</td>
                  <td>05/04/2022 22:29:20</td>
                  <td>3</td>
                  <td>Test Protocol</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>-50</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>20</td>
                  <td>-50.08</td>
                  <td>-50.21</td>
                  <td>-50.21</td>
                  <td>-50.08</td>
                  <td>62.89</td>
                  <td>64.12</td>
                  <td>62.71</td>
                  <td>64.12</td>
                </tr>
                <tr>
                  <td>05/04/2022 22:21:50</td>
                  <td>05/04/2022 22:22:09</td>
                  <td>3</td>
                  <td>Test Protocol</td>
                  <td></td>
                  <td>NULL</td>
                  <td>NULL</td>
                  <td></td>
                  <td>NULL</td>
                  <td>-50</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>20</td>
                  <td>-50.41</td>
                  <td>-50.47</td>
                  <td>-50.47</td>
                  <td>-50.41</td>
                  <td>61.99</td>
                  <td>62.55</td>
                  <td>61.92</td>
                  <td>63.25</td>
                </tr>
                <tr>
                  <td>05/04/2022 17:09:40</td>
                  <td>05/04/2022 17:10:01</td>
                  <td>3</td>
                  <td>Test Protocol</td>
                  <td>test11</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>-50</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>20</td>
                  <td>-49.65</td>
                  <td>-49.81</td>
                  <td>-49.81</td>
                  <td>-49.65</td>
                  <td>63.30</td>
                  <td>62.84</td>
                  <td>62.15</td>
                  <td>63.60</td>
                </tr>
                <tr>
                  <td>05/04/2022 17:06:52</td>
                  <td>05/04/2022 17:07:11</td>
                  <td>3</td>
                  <td>Test Protocol</td>
                  <td>test10</td>
                  <td>10</td>
                  <td>10</td>
                  <td>10</td>
                  <td>10</td>
                  <td>-50</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>20</td>
                  <td>-49.92</td>
                  <td>-50.12</td>
                  <td>-50.12</td>
                  <td>-49.92</td>
                  <td>62.89</td>
                  <td>62.85</td>
                  <td>62.85</td>
                  <td>63.86</td>
                </tr>
                <tr>
                  <td>05/04/2022 17:01:57</td>
                  <td>05/04/2022 17:02:17</td>
                  <td>3</td>
                  <td>Test Protocol</td>
                  <td>test 9</td>
                  <td>9</td>
                  <td>9</td>
                  <td>9</td>
                  <td>9</td>
                  <td>-50</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>20</td>
                  <td>-50.28</td>
                  <td>-50.56</td>
                  <td>-50.56</td>
                  <td>-50.28</td>
                  <td>61.84</td>
                  <td>62.47</td>
                  <td>61.84</td>
                  <td>62.81</td>
                </tr>
                <tr>
                  <td>05/04/2022 16:59:22</td>
                  <td>05/04/2022 16:59:42</td>
                  <td>3</td>
                  <td>Test Protocol</td>
                  <td>test 8</td>
                  <td>8</td>
                  <td>8</td>
                  <td>8</td>
                  <td>8</td>
                  <td>-50</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>20</td>
                  <td>-49.78</td>
                  <td>-50.05</td>
                  <td>-50.05</td>
                  <td>-49.78</td>
                  <td>62.71</td>
                  <td>62.69</td>
                  <td>62.43</td>
                  <td>63.29</td>
                </tr>
                <tr>
                  <td>05/04/2022 16:50:22</td>
                  <td>NULL</td>
                  <td>3</td>
                  <td>Test Protocol</td>
                  <td>NULL</td>
                  <td>NULL</td>
                  <td>NULL</td>
                  <td>NULL</td>
                  <td>NULL</td>
                  <td>-50</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>2000</td>
                  <td>NULL</td>
                  <td>NULL</td>
                  <td>NULL</td>
                  <td>NULL</td>
                  <td>NULL</td>
                  <td>NULL</td>
                  <td>NULL</td>
                  <td>NULL</td>
                </tr>
                <tr>
                  <td>05/04/2022 16:33:55</td>
                  <td>05/04/2022 16:34:15</td>
                  <td>3</td>
                  <td>Test Protocol</td>
                  <td>test 5</td>
                  <td>5</td>
                  <td>5</td>
                  <td>5</td>
                  <td>5</td>
                  <td>-50</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>20</td>
                  <td>-49.71</td>
                  <td>-49.82</td>
                  <td>-49.82</td>
                  <td>-49.71</td>
                  <td>64.81</td>
                  <td>63.30</td>
                  <td>63.01</td>
                  <td>64.81</td>
                </tr>
                <tr>
                  <td>05/04/2022 16:00:18</td>
                  <td>05/04/2022 16:03:47</td>
                  <td>1</td>
                  <td>Vitrafy Protocol 00001</td>
                  <td>Test 4</td>
                  <td>4</td>
                  <td>4</td>
                  <td>4</td>
                  <td>4</td>
                  <td>-52</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>210</td>
                  <td>-49.75</td>
                  <td>-50.31</td>
                  <td>-50.32</td>
                  <td>-49.75</td>
                  <td>62.54</td>
                  <td>60.51</td>
                  <td>60.35</td>
                  <td>63.03</td>
                </tr>
                <tr>
                  <td>05/04/2022 15:36:47</td>
                  <td>05/04/2022 15:40:17</td>
                  <td>1</td>
                  <td>Vitrafy Protocol 00001</td>
                  <td>Test3</td>
                  <td>3</td>
                  <td>3</td>
                  <td>3</td>
                  <td>3</td>
                  <td>-52</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>210</td>
                  <td>-49.85</td>
                  <td>-50.09</td>
                  <td>-50.09</td>
                  <td>-49.85</td>
                  <td>63.65</td>
                  <td>63.67</td>
                  <td>62.81</td>
                  <td>65.39</td>
                </tr>
                <tr>
                  <td>05/04/2022 15:31:18</td>
                  <td>05/04/2022 15:34:48</td>
                  <td></td>
                  <td>Vitrafy Protocol 00001</td>
                  <td>test 2</td>
                  <td>2</td>
                  <td>2</td>
                  <td>2</td>
                  <td>2</td>
                  <td>-52</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>210</td>
                  <td>-49.81</td>
                  <td>-49.64</td>
                  <td>-49.81</td>
                  <td>-49.43</td>
                  <td>39.62</td>
                  <td>41.09</td>
                  <td>38.61</td>
                  <td>41.97</td>
                </tr>
                <tr>
                  <td>05/04/2022 15:25:33</td>
                  <td>05/04/2022 15:29:02</td>
                  <td>1</td>
                  <td>Vitrafy Protocol 00001</td>
                  <td>test 2</td>
                  <td>2</td>
                  <td>2</td>
                  <td>2</td>
                  <td>2</td>
                  <td>-52</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>210</td>
                  <td>-50.59</td>
                  <td>-50.83</td>
                  <td>-50.97</td>
                  <td>-50.59</td>
                  <td>64.23</td>
                  <td>63.09</td>
                  <td>62.35</td>
                  <td>64.80</td>
                </tr>
                <tr>
                  <td>05/04/2022 14:33:00</td>
                  <td>05/04/2022 14:36:30</td>
                  <td>1</td>
                  <td>Vitrafy Protocol 00001</td>
                  <td>test1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>-52</td>
                  <td>1</td>
                  <td>70</td>
                  <td>3</td>
                  <td>210</td>
                  <td>-49.12</td>
                  <td>-49.45</td>
                  <td>-49.45</td>
                  <td>-49.12</td>
                  <td>63.85</td>
                  <td>63.64</td>
                  <td>62.25</td>
                  <td>64.89</td>
                </tr>
                <tr>
                  <td>05/04/2022 13:09:39</td>
                  <td>05/04/2022 13:10:40</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-50.01</td>
                  <td>-49.57</td>
                  <td>-50.01</td>
                  <td>-49.57</td>
                  <td>60.43</td>
                  <td>60.06</td>
                  <td>59.37</td>
                  <td>60.63</td>
                </tr>
                <tr>
                  <td>05/04/2022 12:59:39</td>
                  <td>05/04/2022 13:03:39</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>1.5</td>
                  <td>0.5</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-50.87</td>
                  <td>-50.36</td>
                  <td>-50.87</td>
                  <td>-50.36</td>
                  <td>60.24</td>
                  <td>59.64</td>
                  <td>59.34</td>
                  <td>60.90</td>
                </tr>
                <tr>
                  <td>05/04/2022 11:30:15</td>
                  <td>05/04/2022 11:34:10</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>1.5</td>
                  <td>0.5</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-51.16</td>
                  <td>-50.98</td>
                  <td>-51.18</td>
                  <td>-50.97</td>
                  <td>59.92</td>
                  <td>60.04</td>
                  <td>59.04</td>
                  <td>60.88</td>
                </tr>
                <tr>
                  <td>05/04/2022 11:10:08</td>
                  <td>05/04/2022 11:11:08</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-51.76</td>
                  <td>-51.44</td>
                  <td>-51.78</td>
                  <td>-51.44</td>
                  <td>59.65</td>
                  <td>59.84</td>
                  <td>59.50</td>
                  <td>60.70</td>
                </tr>
                <tr>
                  <td>04/04/2022 13:32:35</td>
                  <td>04/04/2022 13:36:35</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>1.5</td>
                  <td>0.5</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-48.61</td>
                  <td>-48.05</td>
                  <td>-48.62</td>
                  <td>-48.01</td>
                  <td>50.33</td>
                  <td>50.77</td>
                  <td>49.26</td>
                  <td>52.27</td>
                </tr>
                <tr>
                  <td>04/04/2022 13:10:47</td>
                  <td>04/04/2022 13:11:47</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>0</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-49.60</td>
                  <td>-49.08</td>
                  <td>-49.60</td>
                  <td>-49.08</td>
                  <td>59.92</td>
                  <td>60.16</td>
                  <td>59.13</td>
                  <td>60.32</td>
                </tr>
                <tr>
                  <td>30/03/2022 22:05:05</td>
                  <td>30/03/2022 22:05:51</td>
                  <td>3</td>
                  <td>Test Protocol</td>
                  <td>test</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>10</td>
                  <td>1</td>
                  <td>60</td>
                  <td>3</td>
                  <td>45</td>
                  <td>9.94</td>
                  <td>10.04</td>
                  <td>9.94</td>
                  <td>10.04</td>
                  <td>59.70</td>
                  <td>60.18</td>
                  <td>59.53</td>
                  <td>60.45</td>
                </tr>
                <tr>
                  <td>03/11/2021 14:39:19</td>
                  <td>03/11/2021 14:42:19</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Platelets</td>
                  <td>1</td>
                  <td>85</td>
                  <td>50</td>
                  <td>6</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>180</td>
                  <td>-50.44</td>
                  <td>-47.67</td>
                  <td>-50.44</td>
                  <td>-47.66</td>
                  <td>60.37</td>
                  <td>59.88</td>
                  <td>58.90</td>
                  <td>60.78</td>
                </tr>
                <tr>
                  <td>28/10/2021 11:27:32</td>
                  <td>28/10/2021 11:29:32</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>PLTS</td>
                  <td>10</td>
                  <td>2</td>
                  <td>0.5</td>
                  <td>3</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>30</td>
                  <td>10</td>
                  <td>120</td>
                  <td>-50.31</td>
                  <td>-50.52</td>
                  <td>-50.57</td>
                  <td>-50.31</td>
                  <td>35.99</td>
                  <td>31.99</td>
                  <td>12.18</td>
                  <td>45.91</td>
                </tr>
                <tr>
                  <td>28/10/2021 11:24:38</td>
                  <td>28/10/2021 11:26:08</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>PLTS</td>
                  <td>10</td>
                  <td>2</td>
                  <td>0.5</td>
                  <td>3</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>90</td>
                  <td>-50.26</td>
                  <td>-50.42</td>
                  <td>-50.42</td>
                  <td>-50.26</td>
                  <td>59.94</td>
                  <td>60.78</td>
                  <td>59.27</td>
                  <td>61.17</td>
                </tr>
                <tr>
                  <td>26/10/2021 12:30:57</td>
                  <td>26/10/2021 12:32:57</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.25</td>
                  <td>0.2</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>50</td>
                  <td>10</td>
                  <td>120</td>
                  <td>-48.05</td>
                  <td>-48.10</td>
                  <td>-48.10</td>
                  <td>-47.82</td>
                  <td>51.27</td>
                  <td>-2.56</td>
                  <td>-6.25</td>
                  <td>52.72</td>
                </tr>
                <tr>
                  <td>26/10/2021 12:26:44</td>
                  <td>26/10/2021 12:28:45</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.25</td>
                  <td>0.2</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>50</td>
                  <td>10</td>
                  <td>120</td>
                  <td>-49.28</td>
                  <td>-48.57</td>
                  <td>-49.28</td>
                  <td>-48.57</td>
                  <td>50.24</td>
                  <td>49.25</td>
                  <td>47.91</td>
                  <td>51.77</td>
                </tr>
                <tr>
                  <td>26/10/2021 10:05:03</td>
                  <td>26/10/2021 10:09:02</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>1.5</td>
                  <td>0.7</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>50</td>
                  <td>10</td>
                  <td>240</td>
                  <td>-50.57</td>
                  <td>-52.02</td>
                  <td>-52.02</td>
                  <td>-50.57</td>
                  <td>50.54</td>
                  <td>-2.58</td>
                  <td>-6.25</td>
                  <td>75.10</td>
                </tr>
                <tr>
                  <td>20/10/2021 13:44:07</td>
                  <td>20/10/2021 13:46:07</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Platelet sample</td>
                  <td>10</td>
                  <td>1</td>
                  <td>1</td>
                  <td>3</td>
                  <td>-20</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>120</td>
                  <td>-21.37</td>
                  <td>-20.37</td>
                  <td>-21.37</td>
                  <td>-20.37</td>
                  <td>36.58</td>
                  <td>33.37</td>
                  <td>29.28</td>
                  <td>36.81</td>
                </tr>
                <tr>
                  <td>20/10/2021 13:38:03</td>
                  <td>20/10/2021 13:41:02</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Platelet sample</td>
                  <td>2</td>
                  <td>1</td>
                  <td>1</td>
                  <td>3</td>
                  <td>-20</td>
                  <td>2</td>
                  <td>30</td>
                  <td>10</td>
                  <td>180</td>
                  <td>-21.02</td>
                  <td>-22.27</td>
                  <td>-22.36</td>
                  <td>-21.02</td>
                  <td>30.44</td>
                  <td>30.13</td>
                  <td>28.08</td>
                  <td>32.16</td>
                </tr>
                <tr>
                  <td>19/10/2021 12:09:27</td>
                  <td>19/10/2021 12:12:27</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.5</td>
                  <td>0.0.42</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>50</td>
                  <td>10</td>
                  <td>180</td>
                  <td>-50.53</td>
                  <td>-50.00</td>
                  <td>-50.53</td>
                  <td>-49.99</td>
                  <td>51.01</td>
                  <td>42.33</td>
                  <td>41.43</td>
                  <td>51.10</td>
                </tr>
                <tr>
                  <td>19/10/2021 11:54:36</td>
                  <td>19/10/2021 11:56:37</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>6</td>
                  <td>0.25</td>
                  <td>0.2</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>50</td>
                  <td>10</td>
                  <td>120</td>
                  <td>-51.16</td>
                  <td>-50.71</td>
                  <td>-51.16</td>
                  <td>-50.71</td>
                  <td>49.16</td>
                  <td>51.19</td>
                  <td>46.40</td>
                  <td>53.15</td>
                </tr>
                <tr>
                  <td>19/10/2021 10:15:04</td>
                  <td>19/10/2021 10:18:03</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>4</td>
                  <td>0.5</td>
                  <td>0.4</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>50</td>
                  <td>10</td>
                  <td>180</td>
                  <td>-49.26</td>
                  <td>-47.72</td>
                  <td>-49.26</td>
                  <td>-47.72</td>
                  <td>50.54</td>
                  <td>49.39</td>
                  <td>46.90</td>
                  <td>52.42</td>
                </tr>
                <tr>
                  <td>19/10/2021 10:03:22</td>
                  <td>19/10/2021 10:05:22</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>Semen</td>
                  <td>3</td>
                  <td>0.25</td>
                  <td>0.2</td>
                  <td>50</td>
                  <td>-50</td>
                  <td>2</td>
                  <td>50</td>
                  <td>10</td>
                  <td>120</td>
                  <td>-51.26</td>
                  <td>-51.66</td>
                  <td>-51.66</td>
                  <td>-51.06</td>
                  <td>49.95</td>
                  <td>48.46</td>
                  <td>44.61</td>
                  <td>55.88</td>
                </tr>
                <tr>
                  <td>15/07/2021 11:34:44</td>
                  <td>15/07/2021 11:35:44</td>
                  <td>Manual</td>
                  <td>Manual</td>
                  <td>F</td>
                  <td>5</td>
                  <td>6</td>
                  <td>7</td>
                  <td>8</td>
                  <td>-49.70000076</td>
                  <td>2</td>
                  <td>60</td>
                  <td>10</td>
                  <td>60</td>
                  <td>-49.71</td>
                  <td>-49.57</td>
                  <td>-49.71</td>
                  <td>-49.57</td>
                  <td>43.66</td>
                  <td>41.09</td>
                  <td>38.72</td>
                  <td>44.23</td>
                </tr>
              </tbody>
          </table>
        </div>

        <!-- Other Data Table -->
        <div id="tracking-data-other" class="data-table" style="display: none; overflow-x: scroll">
          <br />
          <table class="table">
              <thead>
                <tr>
                    <th>Start DateTime</th>
                    <th>End DateTime</th>
                    <th>Protocol OEMCode</th>
                    <th>Protocol OEMDesc</th>
                    <th>Product Desc</th>
                    <th>Pack Quantity</th>
                    <th>Pack Volume</th>
                    <th>Product Volume</th>
                    <th>CPA</th>
                    <th>Temp Setpoint</th>
                    <th>Temp Tol</th>
                    <th>Flow</th>
                    <th>Flow Tol</th>
                    <th>Process Time</th>
                    <th>Start Temp</th>
                    <th>End Temp</th>
                    <th>Min Temp</th>
                    <th>Max Temp</th>
                    <th>Start Flow</th>
                    <th>End Flow</th>
                    <th>Min Flow</th>
                    <th>Max Flow</th>
                </tr>
              </thead>
              <tbody>
              <tr>
                <td>21/04/2022 13:15:14</td>
                <td>21/04/2022 13:18:14</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>Wb </td>
                <td>4</td>
                <td>10</td>
                <td>40</td>
                <td>0</td>
                <td>-50</td>
                <td>2</td>
                <td>60</td>
                <td>10</td>
                <td>180</td>
                <td>-49.57</td>
                <td>-47.74</td>
                <td>-49.57</td>
                <td>-47.69</td>
                <td>60.03</td>
                <td>60.20</td>
                <td>59.37</td>
                <td>60.60</td>
              </tr>
              <tr>
                <td>21/04/2022 13:08:01</td>
                <td>21/04/2022 13:12:00</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>Wb ld </td>
                <td>7</td>
                <td>1</td>
                <td>5</td>
                <td>0</td>
                <td>-50</td>
                <td>2</td>
                <td>60</td>
                <td>10</td>
                <td>240</td>
                <td>-50.40</td>
                <td>-50.65</td>
                <td>-50.66</td>
                <td>-50.40</td>
                <td>60.05</td>
                <td>59.64</td>
                <td>59.30</td>
                <td>60.91</td>
              </tr>
              <tr>
                <td>13/04/2022 10:04:50</td>
                <td>13/04/2022 10:07:47</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>We l v</td>
                <td>6</td>
                <td>6</td>
                <td>6</td>
                <td>0</td>
                <td>-50</td>
                <td>2</td>
                <td>60</td>
                <td>10</td>
                <td>180</td>
                <td>-51.10</td>
                <td>-48.63</td>
                <td>-51.10</td>
                <td>-48.63</td>
                <td>59.82</td>
                <td>60.25</td>
                <td>59.25</td>
                <td>60.98</td>
              </tr>
              <tr>
                <td>13/04/2022 09:58:51</td>
                <td>13/04/2022 10:00:51</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>Wb l</td>
                <td>2</td>
                <td>10</td>
                <td>10</td>
                <td>0</td>
                <td>-50</td>
                <td>2</td>
                <td>60</td>
                <td>10</td>
                <td>120</td>
                <td>-50.55</td>
                <td>-50.85</td>
                <td>-50.85</td>
                <td>-50.55</td>
                <td>60.89</td>
                <td>60.19</td>
                <td>59.03</td>
                <td>60.89</td>
              </tr>
              <tr>
                <td>06/04/2022 10:46:15</td>
                <td>06/04/2022 10:48:15</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>We l</td>
                <td>3</td>
                <td>1</td>
                <td>1</td>
                <td>0</td>
                <td>-50</td>
                <td>2</td>
                <td>60</td>
                <td>10</td>
                <td>120</td>
                <td>-48.10</td>
                <td>-48.10</td>
                <td>-48.11</td>
                <td>-48.06</td>
                <td>21.76</td>
                <td>21.65</td>
                <td>19.33</td>
                <td>24.10</td>
              </tr>
              <tr>
                <td>06/04/2022 10:16:39</td>
                <td>06/04/2022 10:19:39</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>Wb l</td>
                <td>10</td>
                <td>10</td>
                <td>10</td>
                <td>0</td>
                <td>-50</td>
                <td>2</td>
                <td>60</td>
                <td>10</td>
                <td>180</td>
                <td>-48.10</td>
                <td>-47.80</td>
                <td>-48.10</td>
                <td>-47.80</td>
                <td>28.37</td>
                <td>25.38</td>
                <td>22.70</td>
                <td>30.33</td>
              </tr>
              <tr>
                <td>06/04/2022 10:12:14</td>
                <td>06/04/2022 10:15:15</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>We l</td>
                <td>10</td>
                <td>10</td>
                <td>10</td>
                <td>0</td>
                <td>-50</td>
                <td>2</td>
                <td>60</td>
                <td>10</td>
                <td>180</td>
                <td>-50.73</td>
                <td>-49.08</td>
                <td>-50.73</td>
                <td>-49.08</td>
                <td>40.58</td>
                <td>33.89</td>
                <td>32.72</td>
                <td>42.37</td>
              </tr>
              <tr>
                <td>06/04/2022 10:08:00</td>
                <td>06/04/2022 10:10:59</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>L wb</td>
                <td>3</td>
                <td>30</td>
                <td>30</td>
                <td>0</td>
                <td>-50</td>
                <td>2</td>
                <td>60</td>
                <td>10</td>
                <td>180</td>
                <td>-51.12</td>
                <td>-50.91</td>
                <td>-51.12</td>
                <td>-50.90</td>
                <td>59.70</td>
                <td>49.94</td>
                <td>49.51</td>
                <td>59.70</td>
              </tr>
              <tr>
                <td>05/04/2022 22:21:50</td>
                <td>05/04/2022 22:22:09</td>
                <td>3</td>
                <td>Test Protocol</td>
                <td></td>
                <td>NULL</td>
                <td>NULL</td>
                <td></td>
                <td>NULL</td>
                <td>-50</td>
                <td>1</td>
                <td>70</td>
                <td>3</td>
                <td>20</td>
                <td>-50.41</td>
                <td>-50.47</td>
                <td>-50.47</td>
                <td>-50.41</td>
                <td>61.99</td>
                <td>62.55</td>
                <td>61.92</td>
                <td>63.25</td>
              </tr>
              <tr>
                <td>03/11/2021 14:39:19</td>
                <td>03/11/2021 14:42:19</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>Platelets</td>
                <td>1</td>
                <td>85</td>
                <td>50</td>
                <td>6</td>
                <td>-50</td>
                <td>2</td>
                <td>60</td>
                <td>10</td>
                <td>180</td>
                <td>-50.44</td>
                <td>-47.67</td>
                <td>-50.44</td>
                <td>-47.66</td>
                <td>60.37</td>
                <td>59.88</td>
                <td>58.90</td>
                <td>60.78</td>
              </tr>
              <tr>
                <td>28/10/2021 11:27:32</td>
                <td>28/10/2021 11:29:32</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>PLTS</td>
                <td>10</td>
                <td>2</td>
                <td>0.5</td>
                <td>3</td>
                <td>-50</td>
                <td>2</td>
                <td>30</td>
                <td>10</td>
                <td>120</td>
                <td>-50.31</td>
                <td>-50.52</td>
                <td>-50.57</td>
                <td>-50.31</td>
                <td>35.99</td>
                <td>31.99</td>
                <td>12.18</td>
                <td>45.91</td>
              </tr>
              <tr>
                <td>28/10/2021 11:24:38</td>
                <td>28/10/2021 11:26:08</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>PLTS</td>
                <td>10</td>
                <td>2</td>
                <td>0.5</td>
                <td>3</td>
                <td>-50</td>
                <td>2</td>
                <td>60</td>
                <td>10</td>
                <td>90</td>
                <td>-50.26</td>
                <td>-50.42</td>
                <td>-50.42</td>
                <td>-50.26</td>
                <td>59.94</td>
                <td>60.78</td>
                <td>59.27</td>
                <td>61.17</td>
              </tr>
              <tr>
                <td>20/10/2021 13:44:07</td>
                <td>20/10/2021 13:46:07</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>Platelet sample</td>
                <td>10</td>
                <td>1</td>
                <td>1</td>
                <td>3</td>
                <td>-20</td>
                <td>2</td>
                <td>60</td>
                <td>10</td>
                <td>120</td>
                <td>-21.37</td>
                <td>-20.37</td>
                <td>-21.37</td>
                <td>-20.37</td>
                <td>36.58</td>
                <td>33.37</td>
                <td>29.28</td>
                <td>36.81</td>
              </tr>
              <tr>
                <td>20/10/2021 13:38:03</td>
                <td>20/10/2021 13:41:02</td>
                <td>Manual</td>
                <td>Manual</td>
                <td>Platelet sample</td>
                <td>2</td>
                <td>1</td>
                <td>1</td>
                <td>3</td>
                <td>-20</td>
                <td>2</td>
                <td>30</td>
                <td>10</td>
                <td>180</td>
                <td>-21.02</td>
                <td>-22.27</td>
                <td>-22.36</td>
                <td>-21.02</td>
                <td>30.44</td>
                <td>30.13</td>
                <td>28.08</td>
                <td>32.16</td>
              </tr>  
              </tbody>
          </table>
        </div>
      </div>   
    </div>         

  </div>
</template>
 
<script>
  export default {
    name: "AddGoogleMap",
    data() {
      return {
        ampm: "AM",
        center: { 
              lat: 0,
              lng: -163
        },
        devices: [],
        locationMarkers: [],
        zoom: 3,
        locPlaces: [],
        existingPlace: null,
        showMap: true,
        mapViewText: 'Earth',
        location: "not set",
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        fullscreenControl:false,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },  
        MarkerOptions:{
          zIndex:999999,
          opacity:0.2

        },
        markers: this.marker,
        fullscreen: false,
        currentTime: '',
        currentDate: '',
        autoRotate: true,
        showClock: false,
      };
    },
    mounted() {
      // // current time
      // this.timer = setInterval(() => {
      //   const today = new Date();

      //   let h = today.getHours();
      //   let m = today.getMinutes();
      //   let s = today.getSeconds();

      //   let todayArr = today.toString().split(" ");

      //   //console.log(todayArr);

      //   //let day = todayArr[0];
      //   const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
      //   const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];

      //   let day = weekday[today.getDay()];
      //   let mo = month[today.getMonth()];
      //   let date = todayArr[2];
      //   let y = todayArr[3];

      //   m = this.checkTime(m);
      //   s = this.checkTime(s);
      //   this.ampm = "AM";
      //   if(h > 11) {
      //     this.ampm = "PM"
      //   }
      //   if(h > 12) {
      //     h = h - 12;
      //   }

      //   this.currentTime = h + " : " + m + " : " + s;
      //   this.currentDate = day + ", " + mo + " " + date +  " " + y + " (AEST)";
      // }, 1000) // 1 sec

      console.log("Map mounted " + this.$parent.items.length)

      this.devices = this.$parent.items
      this.locationMarkers = [];
      
      for (var i=0; i < this.$parent.items.length; i++)
      {
        var item = this.$parent.items[i]
        
        var locationItem = {
          position: item.coords,
          title: "Vitrafy",
          label: "Vitrafy",
          device: item.id,
          location: item.location
        }

        this.locationMarkers.push(locationItem)
        this.resetMap();
      }

      // add Vitrafy USA Office
      var newlocationItem = {
          position: {
            lat: 33.65981766521007, 
            lng: -117.741215116961,
          },
        title: "Vitrafy",
        label: "Vitrafy",
        device: "Guardion-00011",
        location: "Vitrafy USA Office"
      }      
      this.locationMarkers.push(newlocationItem)
      this.resetMap();


      console.log("Location markers:")
      console.log(this.locationMarkers)
        },
    watch: {
      // showMap(newValue) {
      //   localStorage.showMap = newValue;
      // }
    },
    methods: {
      resetMap() {
        this.location = null;
        this.infoWinOpen = false;

        document.getElementById("marker-data-container").style.display = 'block';

        document.getElementById("device-info-box").style.display = 'none';  
        document.getElementById("tracking-data-loading").style.display = 'none';
        
        document.getElementById("tracking-data-hobart").style.display = 'none';        
        document.getElementById("tracking-data-ballarat").style.display = 'none';
        document.getElementById("tracking-data-other").style.display = 'none';  
      },
      closeInfoWindow() {
        this.location = null;
        this.infoWinOpen = false;

        document.getElementById("marker-data-container").style.display = 'none';

        document.getElementById("device-info-box").style.display = 'none';  
        document.getElementById("tracking-data-loading").style.display = 'none';
        
        document.getElementById("tracking-data-hobart").style.display = 'none';        
        document.getElementById("tracking-data-ballarat").style.display = 'none';
        document.getElementById("tracking-data-other").style.display = 'none';  
      },
      toggleInfoWindow: function (marker, idx) {
        document.getElementById("device-info-box").style.display = 'none';  
        document.getElementById("tracking-data-loading").style.display = 'none';
        
        document.getElementById("tracking-data-hobart").style.display = 'none';        
        document.getElementById("tracking-data-ballarat").style.display = 'none';
        document.getElementById("tracking-data-other").style.display = 'none';  

        this.infoWindowPos = marker.position;
        this.infoContent = this.getInfoWindowContent(marker);

        //check if its the same marker that was selected if yes toggle
        if (this.location == marker.title) {
          this.location = null;
          this.infoWinOpen = !this.infoWinOpen;
          document.getElementById("marker-data-container").style.display = 'none';
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.markerClick(marker.title);
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },
      getInfoWindowContent: function (marker) {
      return (
      `<div class="">
      <div>
        <div>
          <div class="m-2">
            ${marker.location}
          </div>
        </div>
      </div>
      </div>`);
      },
      markerClick(title) {
        // save to local storage
        localStorage.trackingDataTable = title

        document.getElementById("marker-data-container").style.display = 'block';
        console.log("marker clicked " + title);
        this.location = title;

        document.getElementById("device-info-box").style.display = 'none';  
        document.getElementById("tracking-data-loading").style.display = 'none';
        
        document.getElementById("tracking-data-hobart").style.display = 'none';        
        document.getElementById("tracking-data-ballarat").style.display = 'none';
        document.getElementById("tracking-data-other").style.display = 'none';        
        
        setTimeout(function () {
          document.getElementById("device-info-box").style.display = 'block'; 
          document.getElementById("tracking-data-loading").style.display = 'block';
        }, 300);

        if(title == "Hobart") {
          setTimeout(function () {
            document.getElementById("tracking-data-loading").style.display = 'none';
            document.getElementById("tracking-data-hobart").style.display = 'block';
          }, 2000);
        }

        if(title == "Vitrafy") {
          setTimeout(function () {
            document.getElementById("tracking-data-loading").style.display = 'none';
            document.getElementById("tracking-data-ballarat").style.display = 'block';  
          }, 2000);
        }  

        if(title == "Sydney" || title == "Texas") {
          setTimeout(function () {
            document.getElementById("tracking-data-loading").style.display = 'none';
            document.getElementById("tracking-data-other").style.display = 'block';  
          }, 2000);
        }        
      },
      initMarker(loc) {
        this.existingPlace = loc;
      },
      addLocationMarker() {
        if (this.existingPlace) {
          const marker = {
            lat: this.existingPlace.geometry.location.lat(),
            lng: this.existingPlace.geometry.location.lng()
          };
          this.center = marker;
          this.existingPlace = null;
        }
      },
      clearLocation() {
        this.location=null;
      },
      addNewLocationMarker(lat,lng, id) {
          const marker = {
            lat: lat,
            lng: lng
          };
          this.locationMarkers = [];

          //var icon = "https://googlemapsmarkers.s3.ap-southeast-2.amazonaws.com/marker.png";
          var icon = "";

          this.locationMarkers.push({ 
            position: marker, 
            title: id,
            icon: icon
          });
          
          this.center = marker;
      },    
      locateGeoLocation: function() {
        navigator.geolocation.getCurrentPosition(res => {
          this.center = {
            lat: res.coords.latitude,
            lng: res.coords.longitude
          };
        });
      },
      globbeFullScreen: function() {
        // console.log("globbeFullScreen");

        // document.body.appendChild(document.getElementById("globe"));
        // document.getElementById("globe").classList.add("globeFullScreen");

        // document.body.appendChild(document.getElementById("globeBackground"));
        // document.getElementById("globeBackground").classList.add("globeFullScreen");

        // document.body.appendChild(document.getElementById("closeFFullScreen"));
        // document.getElementById("closeFFullScreen").classList.add("closeFFullScreenActive");

        // document.body.appendChild(document.getElementById("toggleOrbit"));
        // document.getElementById("toggleOrbit").classList.add("closeFFullScreenActiveToggle");

        if(this.fullscreen) {
          this.fullscreen = false;
          this.GoOutFullscreen();
        } else {
          this.fullscreen = true;
          this.GoInFullscreen();
        }
      },
      GoInFullscreen: function() {
            var element = document.getElementById("globeContainer");
            
            if(element.requestFullscreen)
                element.requestFullscreen();
            else if(element.mozRequestFullScreen)
                element.mozRequestFullScreen();
            else if(element.webkitRequestFullscreen)
                element.webkitRequestFullscreen();
            else if(element.msRequestFullscreen)
                element.msRequestFullscreen();
      },
      GoOutFullscreen: function() {
            if(document.exitFullscreen)
                document.exitFullscreen();
            else if(document.mozCancelFullScreen)
                document.mozCancelFullScreen();
            else if(document.webkitExitFullscreen)
                document.webkitExitFullscreen();
            else if(document.msExitFullscreen)
                document.msExitFullscreen();
      },
      mapView: function () {
        console.log("map view clicked");
        if(this.showMap) {
          // hide map
          this.showMap = false;
          localStorage.showMap = this.showMap
          this.mapViewText = "Map";

          // show earth
          document.getElementById("earthControls").style.display = 'block';          
          // document.getElementById("toggleOrbit").style.display = 'block';          
          document.getElementById("globeContainer").style.position = 'relative';
          document.getElementById("globeContainer").style.zIndex = '1';
        } else {
          // show map
          this.showMap = true;
          localStorage.showMap = this.showMap
          this.mapViewText = "Earth";

          // hide earth
          // document.getElementById("toggleOrbit").style.display = 'none';
          document.getElementById("earthControls").style.display = 'none';
          document.getElementById("globeContainer").style.position = 'absolute';
          document.getElementById("globeContainer").style.zIndex = '-1';
        }
      },
      async getLocationTest(row) {
          console.log(row);

              var data = {
                "cellTowers": [
                  {
                    "cellId": row.CELLID,
                    "locationAreaCode": row.LAC,
                    "mobileCountryCode": row.MCC,
                    "mobileNetworkCode": row.MNC,
                    "signalStrength": row.RSSI
                  }
                ]
              }

              data = JSON.stringify(data);

              let headers = {
                  'Content-Type': 'application/json;charset=utf-8'
              };   

          try {
              let url = "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyADlrnhMJmtgQZkNOSHUkbguzXVLHGGt6g";

              const response = await this.$http.post(
                  url,
                  data,
                  {headers: headers}
              );

              // show on map (real data) - TEMP DISABLED
              //this.addNewLocationMarker(response.data.location.lat, response.data.location.lng, row.ID + " " + row.formattedTimestamp)   

              // hard coded to office for demo
              // this.addNewLocationMarker(-37.53092219073088, 143.84338591371284, "Vitrafy Life Sciences"); // Vitrafy Office
              // this.addNewLocationMarker(-42.84173646465064, 147.32082174801945, "Hobart"); // Tas (Hobart)

              //this.addLocationMarker(-37.53092219073088, 143.84338591371284); // Vitrafy Office
              //this.addLocationMarker(-42.84173646465064, 147.32082174801945); // Tas (Hobart)

              console.log(response.data);

              document.getElementById("tracking-loading").style.display = 'none';
              document.getElementById("tracking-container").style.display = 'block';

              this.resetMap();

          } catch (error) {
              console.log(error);
          }                                                    
      },
      checkTime: function(i) {
        if (i < 10) {i = "0" + i}  // add zero in front of numbers < 10
        return i;
      }       
    }
  };
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');

  .settings_input {
    margin-bottom: 5px;
  }

  #earthControls {
    display: none;
  }

  #currentTime {
    margin-top: -10px;
    /* border: 1px solid red; */
    display: inline-block;
    width: 205px;
    text-align: left;
  }

  #ampm {
    display: inline-block;
  }

  #currentDate {
    font-size: 25px;
  }

  #clockContainer {
    /* border: 1px solid red; */
    width: 400px;
    margin: auto;
  }

  #clock {
    position: absolute;
    left: 0px;
    bottom: 10px;
    color: #fff;
    font-size: 40px;
    width: 100%;
    text-align: center;
    font-family: 'Montserrat', sans-serif;
  }

  #vitrafyEarth-logo {
    position: absolute;
    top: 9px;
    left: 11px;
    height: 33px;
  }

  #globeContainer {
    position: absolute;
  }

  #map2d {
    margin-top: 20px;
    height: 100%;
    width: 100%;
    top: 0;
  }

  .globeFullScreen {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
  }

  .closeFFullScreenActive {
    display: block !important;
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 99999;
  }

  #toggleOrbit {
    /* display: none; */
    cursor: pointer;
    position: absolute;
    /* top: 5px; */
    left: 11px;
    z-index: 99999;
  }

  #showClock {
    cursor: pointer;
  }

  .closeFFullScreenActiveToggle {
    display: block !important;
    position: absolute !important;
    top: 20px !important;
    left: 20px !important;
    z-index: 99999 !important;
  }  

  .blackBackground {
    background: #000;
  }

  .displayNone {
    display: none !important;
  }

  #marker-data-container-container{
    background-color: #fff;
    min-height: 500px;
  }
</style>
